module.exports = __webpack_public_path__ + "static/media/image_25.0402576a.png";